// If restore in Freespin (Not on the first freespin), the Intro will do the restore work but not show.
// When restore on the first freespin (the round winning Freespin), show the Intro.


import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TimelineLite} from "gsap";
import {TractorBeamBackgroundEvent} from "../../background/TractorBeamBackground";
import {TractorBeamGameModuleConfig} from "../../TractorBeamGameModuleConfig";
import {TractorBeamFreeSpinIntroScreenView} from "./TractorBeamFreeSpinIntroScreenView";

export class TractorBeamFreeSpinIntroController extends FreespinIntroController {

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }

    protected onCloseComplete():void {
        //TractorBeamGameModuleConfig.particleController.killFadeParticles();
        TractorBeamGameModuleConfig.soundPlayer.switchToFsMusic();
        SlotGame.sound.fadeAmbience(1, 0);

        //super.onCloseComplete();
        this.showKeypad();
        SlotGame.winFieldController.showWinField();
        //EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED));

        EventHandler.dispatchEvent(new GameEvent(TractorBeamBackgroundEvent.TOGGLE_COMMAND_CENTER, true));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }


    show():boolean {
        const view = <TractorBeamFreeSpinIntroScreenView>this._view;

        if(this.shouldShow()) {
            const tl:TimelineLite = new TimelineLite();
            tl.add([
                TractorBeamGameModuleConfig.background.zoomAndPane(true, false, this._serverData),
                () => {
                    this.hideKeypad();
                }
            ]);
            tl.add(() => {
                TractorBeamGameModuleConfig.background.onFSIntroComplete();
                this._isShowing = true;
            }, (!view.isPortrait) ? "+=0.4" : "+=0.4");
            tl.add(() => {
                this._view.show(this._serverData!, () => this.onShowComplete());
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode}));
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
                EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
                //EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
                this._isShowing = true;
            }, "+=1");
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }

        return this._isFreespinWon;
    }

    protected show3():boolean {
        if(this._serverData!.freespinTriggeredThisSpin) {
            //TractorBeamGameModuleConfig.particleController.startProjection(99);
            TractorBeamGameModuleConfig.background.zoomAndPane(true);
        }
        return super.show();
    }

    protected shouldShow():boolean {
        const bool:boolean = super.shouldShow();

        if(this._isRestoreFreespin && !bool) {
            TractorBeamGameModuleConfig.background.zoomAndPane(true, true, this._serverData);
        }

        return bool;
    }
}
